import {useState, useEffect, useCallback, useRef} from 'react'
import {Route, Routes, BrowserRouter } from 'react-router'

import './App.css'
import {Home} from './components/Home'
import {SignUp} from './components/Sign/SignUp'
import {Members} from './components/Member/Members'
import {Registering} from './components/Member/Registering'
import {Courses} from './components/Course/Courses'
import {Classes} from './components/Classe/Classes'
import {Lessons} from './components/Lesson/Lessons'
import {Teams} from './components/Team/Teams'
import {Booking} from './components/Booking/Booking'

import {Managing} from './components/Managing/Managing'
import {Planning} from './components/Planning/Planning'
import {Performing} from './components/Performing/Performing'

import Header from './components/Header'
import Footer from './components/Footer'
import Global from './components/Global'

import {Settings} from './components/Setting/Settings'
import {Persons} from './components/Managing/Persons'
import {Subjects} from './components/Managing/Subjects'
import Reading from './components/Reading/Reading'
import Memorizing from './components/Memorizing/Memorizing'
import Meditating from './components/Meditating/Meditating'
import Repetition from './components/Repetition/Repetition'
import Evaluation from './components/Evaluation/Evaluation'

import {Cookie} from './components/Api'

function App() {
  const global = new Global()  

  const [connected, Connect] = useState(false)
  const [search, Search] = useState("")
  const [course, Course] = useState(1)
  const [team, Team] = useState(1)
  const [etat, Etat] = useState("")
  const [role, Role] = useState(0)
  const [layout, Layout] = useState(window.matchMedia('(orientation:landscape)').matches)

  const current = sessionStorage.getItem("routeCurrent") 
  const route = useRef(current ?? '/') 

  useEffect(() => {
    global.checkVersion()
    
    Connect(global.connected())
    //  alert(`connected: ${global.connected()}`)
  },[])

  
useEffect(()=>{
  if(connected) {
    let cookie = Cookie('meCourse') ?? course
    //alert(`course = ${course}`)
    Course(parseInt(cookie))
  }
},[connected])

/*
const onResize = useCallback(event => {
    if(route.current!=="/memorizing") { //  
      let value=window.matchMedia('(orientation:landscape)').matches    
      Layout(value)
      //console.log('window.matchMedia.matches',value) //; alert(value)
    }
  }, [])

useEffect(() => {
          window.addEventListener("resize", onResize);
          return () => {
              window.removeEventListener("resize", onResize);
          };
  }, [onResize, layout])
*/

  return (
<BrowserRouter>
    <Header connected={connected} onSearch={Search} onRole={Role} layout={layout} route={current} />

    <Routes>
      <Route path='/' element={ <Home connected={connected} />} exact />
      <Route path='/signup' element={ <SignUp connected={connected} />} />

      <Route path='/member' element={ <Members global={global} search={search} />} />
      <Route path='/registering' element={ <Registering global={global} />} />
      <Route path='/team' element={ <Teams global={global} search={search} role={role} Etat={Etat} />} />

      <Route path='/classe' element={ <Classes global={global} id={2} />} />        
      <Route path='/lesson' element={ <Lessons global={global} />} />

      <Route path='/managing' element={ <Managing global={global} layout={layout} search={search}  />} />
      <Route path='/planning' element={ <Planning global={global} role={role} course={course} search={search} />} />
      <Route path='/booking' element={ <Booking global={global} layout={layout} search={search} />} />
      <Route path='/performing' element={ <Performing global={global} search={search} Etat={Etat} />} />

      <Route path='/setting' element={ <Settings global={global} search={search} role={role} Etat={Etat} />} />
      <Route path='/person' element={ <Persons global={global} layout={layout} search={search} />} />
      <Route path='/subject' element={ <Subjects global={global} course={course} layout={layout} role={role} search={search} />} />
      <Route path='/reading' element={ <Reading layout={layout} search={search} Etat={Etat} />} />
      <Route path='/repetition' element={ <Repetition course={course} layout={layout} search={search} onEtat={Etat} />} />
      <Route path='/evaluation' element={ <Evaluation team={team} layout={layout} search={search} onEtat={Etat} />} />

      <Route path='/course' element={ <Courses onCourse={Course} global={global} role={role} />} /> 
      <Route path='/memorizing' element={ <Memorizing search={search} onEtat={Etat} role={role} course={course} layout={layout} />} />
      <Route path='/meditating' element={ <Meditating search={search} onEtat={Etat} role={role} course={course} layout={layout} />} />

    </Routes>

    <Footer etat={etat}/>

  </BrowserRouter>

  )
}

export default App;

